class Form {
	stateClasses = {
		error: 'input-group--error',
	};

	constructor($el) {
		this.$el = $el;
		this.$content = $el.find('[data-form="content"]');
		this.$form = $el.find('[data-form="form"]');
		this.$success = $el.find('[data-form="success"]');
		this.$submit = $el.find('[data-form="submit"]');
		this.$inputGroup = $el.find('[data-form="input-group"]');
		this.safari = navigator.userAgent.indexOf('Safari') > -1;

		this.$form.on('submit', this.submitHandler);
	}

	submitHandler = e => {
		e.preventDefault();

		const form = e.target;

		const data = new FormData(form);
		let request = new XMLHttpRequest();

		console.log('form', form);

		if (this.safari) {
			for (var i = 0; i < form.elements.length; i++) {
				if (form.elements[i].type == 'file') {
					if (form.elements[i].value == '') {
						var elem = form.elements[i];
						data.delete(elem.name);
					}
				}
			}
		}

		const method = form.getAttribute('method');
		const action = form.getAttribute('action');

		request.open(method, action ? action : window.location.href, true);
		request.setRequestHeader('Cache-Control', 'no-cache');
		request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
		request.setRequestHeader('HTTP_X_REQUESTED_WITH', 'XMLHttpRequest');
		request.setRequestHeader('Accept', 'application/json');

		this.lockSubmit();

		request.onload = () => {
			this.removeErrors();
			if (request.status === 200) {
				const response = JSON.parse(request.response);

				console.log('response', response);

				if (response.success) {
					this.handleSuccess();
				} else if (response.errors) {
					this.showErrors(response.errors);
				}
			} else {
				console.error(request);
			}
			this.unlockSubmit();
		};

		request.send(data);
	};

	lockSubmit = () => {
		this.$submit.prop('disabled', true);
	};

	unlockSubmit = () => {
		this.$submit.prop('disabled', false);
	};

	handleSuccess = () => {
		this.$content.remove();

		this.$success.removeClass('d-none');
	};

	showErrors = errors => {
		for (var key in errors) {
			const $input = this.$el.find(`[name="${key}"]`);
			const $inputGroup = $input.closest('[data-form="input-group"]');
			$inputGroup.addClass(this.stateClasses.error);
		}
	};

	removeErrors = () => {
		this.$inputGroup.removeClass(this.stateClasses.error);
	};
}

export default Form;
